import * as React from "react";
import Slider from "react-slick";
import moment from "moment";
import {
  Project,
  PropertyDetails,
  Unit,
} from "../../../core/api/models/project";
import BottomPagination from "../../../core/components/pagination/BottomPagination";
import { PaginatedApiResponse } from "../../../core/api/models/response";
import RequirementPropertyDetailPage from "../../requirement/components/RequirementPropertyDetail";
import { usePerformAction } from "react-remote-data-hooks";
import api from "../../../api";
import { toastr } from "react-redux-toastr";
import { AppPermissions, convertPascalCaseToWords, htmlDecode, useHasPermission } from "../../../core";
import { ContainerLoader } from "../../../components/loader";
import BlankProPic from "../../../styles/images/no-user-sm.png";
import PhoneNumberCopy from "../../../components/phoneNumberCopy/PhoneNumberCopy";
import EmailLink from "../../../components/emailLink/EmailLink";
import PropertyDetailPage from "../../property-details/PropertyDetailPage";

const SearchProperty: React.FunctionComponent<{
  properyData?: PaginatedApiResponse<Project>;
  page?: number;
  perPage?: number;
  setPage?: (pg: number) => void;
  setPerPage?: (pg: number) => void;
  requirementVersion?: number;
  requirementId?: string;
  reload?: () => void;
  onSelect: (propertys: PropertyDetails[]) => void;
  selectedProperties: PropertyDetails[];
  sortList?: any[];
  allLoaded: boolean;
  loading: boolean;
}> = (props) => {
  const [projectDetailModal, setProjectDetailModal] = React.useState<{
    isOpen?: boolean;
    projectId?: string;
  }>({});
  const [propertyDetailModal, setPropertyDetailModal] = React.useState<{
        isOpen?: boolean;
        propertyId?: string;
  }>({});
  const canViewProject = useHasPermission(AppPermissions.ViewProject);
  const canViewProperty = useHasPermission(AppPermissions.ViewProperty);
  const [dropPos, setDropPos] = React.useState<{
    open: boolean;
    x: string;
    y: string;
    id: string;
    fieldName: string;
}>();


const dropdownClick = (event: any, id: string, fieldName: string) => {
  const pos = event.target.getBoundingClientRect();
  const x = pos.x + "px";
  const y = pos.y + pos.height + "px";
  setDropPos({ open: !dropPos?.open, x, y, id, fieldName });
};

const renderFieldDetails = (fieldName: string, fieldArrayValues: any) => {
return (
  <div
      className="position-absolute bg-white shadow w-100 pt-2"
      style={{ right: 0 , maxWidth: "435px", zIndex: 100 }}
  >
      <div className="px-3 pt-2 font-normal text-gray-600 font-weight-semibold my-1">
          {fieldName}
      </div>
      {fieldArrayValues?.map((item: any, index: number) => {
          return (
              <div className="d-flex align-items-center text-nowrap py-2 px-3 border-bottom" key={index}>
                  <img
                      src={item?.profileImage ? item?.profileImage : BlankProPic}
                      alt="image_not_found"
                      className="img-cover rounded-circle img-responsive mr-2"
                      width={26}
                      height={26}
                  />
                  <div className="font-weight-semibold">
                      <div className="font-normal">
                          {item.contactName}
                      </div>
                      <div className="font-xs text-gray-600 d-flex align-items-center">
                          {item.phones.map((itm:any, idx:number)=><><PhoneNumberCopy>{itm.phone}</PhoneNumberCopy>{++idx < item?.phones?.length ? ', ' : '' }</>)}
                      </div>
                      <div className="font-xs text-gray-600 d-flex align-items-center">
                          {item.emails.map((itm:any, idx:number)=><><EmailLink>{itm.email}</EmailLink>{++idx < item.emails.length ? ', ' : ''}</>)}
                      </div>
                      <div className="font-xs text-gray-600 d-flex align-items-center">
                          {item?.type}
                      </div>
                  </div>
              </div>
          );
      })}
  </div>
);  
  
};

  const [propDropdown, setPropDropdown] = React.useState<number | null>(null);

  const [selectedProperty, setSelectedProperty] = React.useState<
    PropertyDetails[]
  >(props.selectedProperties || []);

  const onAllSelected = (selected: boolean, project: Project) => {
    const allValues = !selected
      ? ([] as PropertyDetails[])
      : (project?.unitDetails
          ?.filter((x) => x.propertyID !== "0" && Number(x.propertyID) !== 0)
          ?.map((ut: Unit) => {
            const property = ut.propertyID
              ? project?.properties?.find(
                  (p) => p.propertyID?.toString() === ut.propertyID?.toString()
                )
              : undefined;
            return {
              floor: ut.floorName,
              unitId: ut.unitID,
              unitName: ut.unitName,
              area: ut.unitArea,
              interiorType: property?.attribute?.interiorType,
              quotedRent: property?.attribute?.quotedRentPerSqFtPerMonth,
              currentStatus: property?.propertyAvailableStatus,
              availableFrom: property?.availablefromdate,
              projectId: project?._id,
              propertyId: property?._id,
              propertyName: property?.propertyName,
              propertyAddress: property?.propertyAddress1,
              propertyCoverImage: property?.propertyCoverImage,
              propertySqrFeet: property?.propertySqrFeet,
              developer: project?.projectBuilderName,
              pricePerSqft: property?.pricePerSqft,
              availableUnits: property?.availableUnits,
              requirementVersion: props.requirementVersion,
              projectName: project?.projectName,
              latitude: property?.proLatitude,
              longitude: property?.proLongitude,
              cityName: property?.cityName,
              cityLocName: property?.cityLocName,
              isNew: true,
              propertyDetails: {contactDetails :(property?.contactDetails || [])}
            };
          }) as PropertyDetails[]);
    setSelectedProperty([
      ...(selectedProperty?.filter(
        (p) => p.projectId?.toString() !== project?._id?.toString()
      ) || []),
      ...(allValues || []),
    ]);
  };

  const onSelect = (ut: Unit, sel: boolean, project: Project) => {
    if (sel) {
      const property = ut.propertyID
        ? project?.properties?.find(
            (p) => p.propertyID?.toString() === ut.propertyID?.toString()
          )
        : undefined;

      setSelectedProperty([
        ...(selectedProperty || []),
        {
          floor: ut.floorName,
          unitId: ut.unitID,
          unitName: ut.unitName,
          area: ut.unitArea,
          interiorType: property?.attribute?.interiorType,
          quotedRent: property?.attribute?.quotedRentPerSqFtPerMonth,
          currentStatus: property?.propertyAvailableStatus,
          availableFrom: property?.availablefromdate,
          projectId: project?._id,
          propertyId: property?._id,
          propertyName: property?.propertyName,
          propertyAddress: property?.propertyAddress1,
          propertyCoverImage: property?.propertyCoverImage,
          propertySqrFeet: property?.propertySqrFeet,
          developer: project?.projectBuilderName,
          pricePerSqft: property?.pricePerSqft,
          availableUnits: property?.availableUnits,
          requirementVersion: props.requirementVersion,
          projectName: project?.projectName,
          latitude: property?.proLatitude,
          longitude: property?.proLongitude,
          cityName: property?.cityName,
          cityLocName: property?.cityLocName,
          isNew: true,
          propertyDetails: {contactDetails :(property?.contactDetails || [])}
        },
      ]);
    } else {
      setSelectedProperty(
        selectedProperty?.filter((val) => val.unitId !== ut.unitID) || []
      );
    }
  };
   
  const {
    performAction: createShortList,
    isPerforming: isSaving,
  } = usePerformAction(
    () =>
      api.shortlist.createShortList({
        requirementId: props.requirementId!,
        propertyDetails: selectedProperty!,
      }),
    () => {
      toastr.success("Success", "Added to Shortlist");
      props.reload?.();
    },
    () => {
      toastr.error("Error", "Unable to add to Shortlist");
    }
  );

  const settings = {
    className: "require-slider",
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: true,
    autoplay: false,
  };

  const ordinalSuffixOf = (i: number) => {
    const j = i % 10;
    const k = i % 100;
    if (j === 1 && k !== 11) {
      return i + "st";
    }
    if (j === 2 && k !== 12) {
      return i + "nd";
    }
    if (j === 3 && k !== 13) {
      return i + "rd";
    }
    return i + "th";
  };

  if (props.allLoaded && props.loading) {
    return <ContainerLoader></ContainerLoader>;
  }

  return !!props.properyData?.data?.length ? (
    <>
      <div
        className="py-3 px-2 border-top border-bottom d-flex align-items-center mb-1"
        style={{ background: "rgba(160, 160, 160, 0.06)" }}
      >
        <div className="font-sm text-gray-500">
          <span className="text-gray-700">{props.properyData?.itemsCount}</span>{" "}
          Properties,{" "}
          <span className="text-gray-700">{props.properyData?.count}</span>{" "}
          Projects
        </div>
        <div className="inline-flex font-xs text-gray-500 border-left ml-4 pl-4">
          <svg
            width="19"
            height="15"
            viewBox="0 0 19 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Group 2040">
              <g id="Group">
                <path
                  id="Vector"
                  d="M8.65622 12.3984H0.579535C0.259458 12.3984 0 12.6579 0 12.978V13.5575C0 13.8776 0.259458 14.137 0.579535 14.137H8.65622C8.97624 14.137 9.23575 13.8776 9.23575 13.5575V12.978C9.23575 12.6579 8.9763 12.3984 8.65622 12.3984Z"
                  fill="#6F7171"
                />
                <path
                  id="Vector_2"
                  d="M0.579535 10.4847H7.56791C7.88793 10.4847 8.14745 10.2252 8.14745 9.90516V9.32563C8.14745 9.00555 7.88793 8.74609 7.56791 8.74609H0.579535C0.259458 8.74609 0 9.00555 0 9.32563V9.90516C0 10.2252 0.259458 10.4847 0.579535 10.4847Z"
                  fill="#6F7171"
                />
                <path
                  id="Vector_3"
                  d="M0.579535 6.83235H6.47949C6.79951 6.83235 7.05902 6.5729 7.05902 6.25282V5.67328C7.05902 5.35321 6.79951 5.09375 6.47949 5.09375H0.579535C0.259458 5.09375 0 5.35321 0 5.67328V6.25282C0 6.5729 0.259458 6.83235 0.579535 6.83235Z"
                  fill="#6F7171"
                />
                <path
                  id="Vector_4"
                  d="M0.579535 2.77767H5.39112C5.71114 2.77767 5.97066 2.51821 5.97066 2.19813V1.6186C5.97066 1.29852 5.71114 1.03906 5.39112 1.03906H0.579535C0.259458 1.03906 0 1.29852 0 1.6186V2.19813C0 2.51821 0.259458 2.77767 0.579535 2.77767Z"
                  fill="#6F7171"
                />
                <path
                  id="Vector_5"
                  d="M18.5371 9.73898L18.1273 9.32919C18.0187 9.22053 17.8712 9.15945 17.7175 9.15945C17.5638 9.15945 17.4165 9.22053 17.3077 9.32919L15.3145 11.3224V1.16547C15.3145 0.845395 15.055 0.585938 14.735 0.585938H14.1554C13.8354 0.585938 13.5759 0.845395 13.5759 1.16547V11.3223L11.5826 9.32914C11.4739 9.22041 11.3265 9.15939 11.1728 9.15939C11.0192 9.15939 10.8717 9.22047 10.7631 9.32914L10.3533 9.73892C10.127 9.96523 10.127 10.3322 10.3533 10.5585L14.0354 14.2406C14.1441 14.3493 14.2915 14.4104 14.4452 14.4104C14.5989 14.4104 14.7463 14.3493 14.855 14.2406L18.5371 10.5585C18.7634 10.3322 18.7634 9.96529 18.5371 9.73898Z"
                  fill="#6F7171"
                />
              </g>
            </g>
          </svg>
          {/* <svg
            width="20px"
            height="15px"
            viewBox="0 0 20 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                fill="#6F7171"
                d="M10.031,2.197V1.618c0-0.319-0.26-0.579-0.58-0.579H1.375c-0.32,0-0.58,0.26-0.58,0.579v0.579
		c0,0.32,0.259,0.58,0.58,0.58h8.077C9.771,2.777,10.031,2.518,10.031,2.197z"
              />
              <path
                fill="#6F7171"
                d="M0.795,5.269v0.579c0,0.32,0.259,0.58,0.58,0.58h6.988c0.32,0,0.58-0.26,0.58-0.58V5.269
		c0-0.319-0.26-0.579-0.58-0.579H1.375C1.054,4.689,0.795,4.949,0.795,5.269z"
              />
              <path
                fill="#6F7171"
                d="M0.795,8.921V9.5c0,0.32,0.259,0.58,0.58,0.58h5.9c0.32,0,0.58-0.26,0.58-0.58V8.921
		c0-0.319-0.26-0.579-0.58-0.579h-5.9C1.054,8.342,0.795,8.602,0.795,8.921z"
              />
              <path
                fill="#6F7171"
                d="M0.795,12.978v0.579c0,0.32,0.259,0.58,0.58,0.58h4.812c0.32,0,0.58-0.26,0.58-0.58v-0.579
		c0-0.319-0.26-0.579-0.58-0.579H1.375C1.054,12.398,0.795,12.658,0.795,12.978z"
              />
            </g>
            <path
              fill="#6F7171"
              d="M19.332,4.439L15.65,0.758c-0.109-0.109-0.256-0.17-0.41-0.17s-0.301,0.061-0.41,0.17l-3.682,3.682
	c-0.227,0.227-0.227,0.594,0,0.82l0.41,0.409c0.107,0.108,0.256,0.17,0.409,0.17s0.302-0.062,0.409-0.17l1.994-1.993v10.156
	c0,0.32,0.26,0.58,0.579,0.58h0.579c0.32,0,0.58-0.26,0.58-0.58V3.676l1.993,1.993c0.108,0.108,0.257,0.17,0.41,0.17
	s0.301-0.062,0.409-0.17l0.41-0.409C19.559,5.033,19.559,4.666,19.332,4.439z"
            />
          </svg> */}

          <span className="ml-1">Sort</span>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table w-100">
          {props.properyData?.data?.map((item, index) => {
            const unitDetails = item.unitDetails
              ?.filter(
                (x) => x.propertyID !== "0" && Number(x.propertyID) !== 0
              )
              ?.sort((a, b) => (a.floorName < b.floorName ? -1 : 1));

            const floors = [
              ...new Set(unitDetails?.map((f) => f.floorName)),
            ].sort();

            const availableUnit = unitDetails?.filter((x) =>
              item.properties?.find(
                (p) =>
                  p.propertyID?.toString() === x.propertyID?.toString() &&
                  p.propertyAvailableStatus === "available"
              )
            )?.length;

            const allUnit = unitDetails?.filter((x) =>
              item.properties?.find(
                (p) => p.propertyID?.toString() === x.propertyID?.toString()
              )
            )?.length;

            const isShortListed = !!props.sortList?.find(
              (x) => x.propertyDetailsFromProject?.projectId === item._id
            );

            return (
              <>
                <tr
                  className={`require-row ${
                    propDropdown === index ? "active" : ""
                  }`}
                >
                  <td
                    className="py-2 border-bottom"
                    style={{ maxWidth: "40px", width: "40px" }}
                  >                    
                    <div className="py-1">
                      <input
                        type="checkbox"
                        name={`properyCheck-${item.projectID}`}
                        id={`properyCheck-${item.projectID}`}
                        onChange={(e) => onAllSelected(e.target.checked, item)}
                        checked={
                          selectedProperty?.filter(
                            (ff) => ff.projectId === item._id
                          )?.length === unitDetails?.length &&
                          !!unitDetails?.length
                        }
                      />
                      <label htmlFor={`properyCheck-${item.projectID}`}></label>
                    </div>
                  </td>
                  <td
                    className="py-2 border-bottom"
                    style={{ maxWidth: "90px" }}
                  >
                    <div className="py-1">
                      <img
                        src={
                          item.projectBannerImage ||
                          require(`../../../assets/images/color-noimage-lg.png`)
                        }
                        alt={item.projectName}
                        width={59}
                        height={45}
                        className="img-cover"
                      />
                    </div>
                  </td>
                  <td
                    className="py-2 border-bottom"
                    style={{ width: "290px", maxWidth: "290px" }}
                    role="button"
                    onClick={() =>
                         setProjectDetailModal({
                        isOpen: true,
                        projectId: item?._id,
                      })
                    }
                  >
                    <div className="py-1 w-100 px-3">
                      <div className="font-sm text-truncate">
                        {item.projectName}
                      </div>
                      <div className="font-xs text-gray-500">
                        {htmlDecode(item.projectAddress1)}
                      </div>
                      {isShortListed && (
                        <span className="tag--active font-xxs">
                          Short Listed
                        </span>
                      )}
                    </div>
                  </td>

                  <td className="py-2 border-bottom">
                    <div className="py-1 font-xs text-gray-800">
                      <span className="text-gray-500">Developer:</span>{" "}
                      {item.projectBuilderName}
                    </div>
                  </td>
                  <td className="py-2 border-bottom">
                    <div className="py-1" style={{ whiteSpace: "nowrap" }}>
                      <div className="font-xxs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2 mb-2">
                        <b className="text-gray-800 font-xs">
                          {String(availableUnit).padStart(2, "0")}
                        </b>{" "}
                        /{String(allUnit).padStart(2, "0")} Matching
                      </div>
                      <div className="font-xs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2 mb-2">
                        Unit matching : {String(availableUnit).padStart(2, "0")}
                      </div>
                      <div className="font-xs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2 mb-2">
                        Floor matching :{String(availableUnit).padStart(2, "0")}
                      </div>
                    </div>
                  </td>
                  <td className="py-2 border-bottom" style={{ width: "80px" }}>
                    {!!selectedProperty?.filter((x) => x.projectId === item._id)
                      ?.length && (
                      <div className="border border-primary  px-1 px-2 py-1 text-primary w-75 selectproperty-ico font-md align-items-center rounded-lg d-flex justify-content-center">
                        {
                          selectedProperty?.filter(
                            (x) => x.projectId === item._id
                          )?.length
                        }
                        <svg
                          className="ml-1"
                          width="16"
                          height="21"
                          viewBox="0 0 25 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Group">
                            <path
                              id="Vector"
                              d="M20.7748 0.846845C18.0794 -0.593747 14.5243 -0.156234 12.2903 1.85387C10.0454 -0.154626 6.48464 -0.587461 3.79831 0.846845C1.45711 2.0882 0 4.4655 0 7.04673C0 7.78581 0.12279 8.52021 0.340012 9.15287C1.48591 14.1129 8.84221 20.64 12.2903 20.64C15.7309 20.64 23.0816 14.1123 24.2078 9.23692C24.4493 8.51948 24.5725 7.78683 24.5725 7.046C24.5727 4.4655 23.1169 2.08732 20.7748 0.846845ZM22.5345 8.76258C21.4683 13.3786 14.5215 18.8996 12.2903 18.8996C9.80714 18.8996 3.0414 13.1158 2.01347 8.67867C1.82987 8.14351 1.74157 7.59563 1.74157 7.04775C1.74157 5.1122 2.84172 3.32341 4.61223 2.38435C5.43668 1.94275 6.37457 1.71486 7.32268 1.71486C8.99146 1.71486 10.5623 2.4228 11.6338 3.6602L12.2979 4.42019L12.952 3.6602C14.6207 1.72377 17.6859 1.16698 19.9642 2.38435C21.7347 3.32341 22.835 5.1122 22.835 7.04775C22.8314 7.59461 22.7425 8.14263 22.5345 8.76258Z"
                              fill="#4161c8"
                            />
                          </g>
                        </svg>
                      </div>
                    )}
                  </td>
                  <td className="py-2 border-bottom">
                    <div
                      className="py-1 cursor-pointer"
                      onClick={() =>
                        propDropdown === index
                          ? setPropDropdown(null)
                          : setPropDropdown(index)
                      }
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="chevron-down (98) 1">
                          <path
                            id="Vector"
                            d="M6 9L12 15L18 9"
                            stroke="#272B2A"
                            stroke-width="1.4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                      </svg>
                    </div>
                  </td>
                </tr>
                {propDropdown === index && (
                  <tr>
                    <td colSpan={7}>
                      <div
                        className="py-4 pr-4 pl-5"
                        style={{ maxWidth: "90vw" }}
                      >
                        <Slider {...settings}>
                          <div className="border rounded p-2 d-inline-block mr-1 w-auto">
                            <div className="font-xs font-weight-semibold title d-flex align-items-end">
                              Matching Unit{" "}
                              {!!selectedProperty?.filter(
                                (ff) => ff.projectId === item._id
                              )?.length && (
                                <span className="count-filter mx-2 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center ml-1">
                                  {
                                    selectedProperty?.filter(
                                      (ff) => ff.projectId === item._id
                                    )?.length
                                  }
                                </span>
                              )}
                            </div>
                            <div className="font-xs font-weight-medium text-gray-700">
                              {
                                unitDetails?.filter((x) =>
                                  item.properties?.find(
                                    (p) =>
                                      p.propertyID?.toString() ===
                                        x.propertyID?.toString() &&
                                      p.propertyAvailableStatus === "available"
                                  )
                                )?.length
                              }{" "}
                              Available, {unitDetails?.length} Total
                            </div>
                          </div>
                          {floors?.map((fl) => {
                            const availableCount = unitDetails?.filter(
                              (x) =>
                                item.properties?.find(
                                  (p) =>
                                    p.propertyID?.toString() ===
                                      x.propertyID?.toString() &&
                                    p.propertyAvailableStatus === "available"
                                ) && x.floorName === fl
                            )?.length;
                            const totalCount = unitDetails?.filter(
                              (x) => x.floorName === fl
                            )?.length;

                            return (
                              <>
                                <div className="border rounded p-2 d-inline-block mr-1 w-auto">
                                  {fl === 0 ? (
                                    <div className="font-xs font-weight-semibold title d-flex align-items-end">
                                      Ground Floor
                                      {!!selectedProperty?.filter(
                                        (ff) =>
                                          ff.projectId === item._id &&
                                          ff.floor === fl
                                      )?.length && (
                                        <span className="count-filter mx-2 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center ml-1">
                                          {
                                            selectedProperty?.filter(
                                              (ff) =>
                                                ff.projectId === item._id &&
                                                ff.floor === fl
                                            )?.length
                                          }
                                        </span>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="font-xs font-weight-semibold title d-flex align-items-end">
                                      {ordinalSuffixOf(Number(fl))} Floor
                                      {!!selectedProperty?.filter(
                                        (ff) =>
                                          ff.projectId === item._id &&
                                          ff.floor === fl
                                      )?.length && (
                                        <span className="count-filter mx-2 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center ml-1">
                                          {
                                            selectedProperty?.filter(
                                              (ff) =>
                                                ff.projectId === item._id &&
                                                ff.floor === fl
                                            )?.length
                                          }
                                        </span>
                                      )}
                                    </div>
                                  )}
                                  <div className="font-xs font-weight-medium text-gray-700">
                                    {availableCount} Available, {totalCount}{" "}
                                    Total
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </Slider>
                      </div>
                      <div>
                        <table className="table table-bordered w-100 font-sm">
                          <tr>
                            <td
                              className="py-2  px-2   border-bottom px-1"
                              style={{ maxWidth: "40px", width: "40px" }}
                            >
                              <div className="">                              
                                <input
                                  type="checkbox"
                                  name={`propertyCheck-unit-${item.projectID}`}
                                  id={`propertyCheck- px-2 -${item.projectID}`}
                                  onChange={(e) =>
                                    onAllSelected(e.target.checked, item)
                                  }
                                  checked={
                                    selectedProperty?.filter(
                                      (ff) => ff.projectId === item._id
                                    )?.length === unitDetails?.length &&
                                    !!unitDetails?.length
                                  }
                                />
                                <label
                                  htmlFor={`propertyCheck- px-2 -${item.projectID}`}
                                ></label>
                              </div>
                            </td>
                            <td className="py-2 border-bottom">
                              <div className="py-1">Floor</div>
                            </td>
                            <td className="py-2 border-bottom">
                              <div className="py-1">Unit Id</div>
                            </td>
                            <td className="py-2 border-bottom">
                              <div className="py-1">Area (in Sq.Ft)</div>
                            </td>
                            <td className="py-2 border-bottom">
                              <div className="py-1">Interior Type</div>
                            </td>
                            <td className="py-2 border-bottom">
                              <div className="py-1">Quoted Rent</div>
                            </td>
                            <td className="py-2 border-bottom">
                              <div className="py-1">Current Status</div>
                            </td>
                            <td className="py-2 border-bottom">
                              <div className="py-1">Available From</div>
                            </td>
                            <td className="py-2 border-bottom font-sm">
                               <div className="py-1">Contact Details</div>
                             </td>
                          </tr>
                          {unitDetails?.map((unit:any) => {
                            const property: any = unit.propertyID
                            ? item?.properties?.find(
                              (p) =>
                              p.propertyID?.toString() ===
                              unit.propertyID?.toString()
                              )
                              : undefined;

                            const isShorted = !!props.sortList?.find(
                              (x) =>
                                x.propertyDetailsFromProject?.unitId?.toString() ===
                                unit?.unitID?.toString()
                            );
                            return (
                              <>
                                <tr
                                  role="button"
                                  onClick={() => {
                                    if (property?.propertyAvailableStatus === "available") {
                                      setPropertyDetailModal({
                                        isOpen: true,
                                        propertyId: property._id,
                                      })
                                    }
                                  }}
                                >
                                  <td
                                    className="py-3 px-2 border-bottom px-0"
                                    style={{ maxWidth: "40px", width: "40px" }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <div className="">
                                      <input
                                        type="checkbox"
                                        name={`propertyCheck-${unit.unitID}-${item.projectID}`}
                                        id={`propertyCheck-${unit.unitID}-${item.projectID}`}
                                        onChange={(e) =>
                                          onSelect(unit, e.target.checked, item)
                                        }
                                        checked={
                                          !!selectedProperty?.find(
                                            (fv) => fv.unitId === unit.unitID
                                          )
                                        }
                                      />
                                      <label
                                        htmlFor={`propertyCheck-${unit.unitID}-${item.projectID}`}
                                      ></label>
                                    </div>
                                  </td>
                                  <td className="py-3 border-bottom">
                                    <div className="">{unit.floorName}</div>
                                  </td>
                                  <td className="py-3 border-bottom">
                                    <div className="">{unit.unitName}</div>
                                    {isShorted && (
                                      <span className="tag--active font-xxs">
                                        Short Listed
                                      </span>
                                    )}
                                  </td>
                                  <td className="py-3 border-bottom">
                                    <div className="">{unit.unitArea}</div>
                                  </td>
                                  <td className="py-3 border-bottom">
                                    <div className="">
                                      {property?.attribute?.interiorType}
                                    </div>
                                  </td>
                                  <td className="py-3 border-bottom">
                                    <div className="">
                                      {
                                        property?.attribute
                                          ?.quotedRentPerSqFtPerMonth
                                      }{" "}
                                    </div>
                                  </td>
                                  <td className="py-3 border-bottom">
                                    <div className="">
                                      {convertPascalCaseToWords(
                                        property?.propertyAvailableStatus
                                      )}
                                    </div>
                                  </td>
                                  <td className="py-3 border-bottom">
                                    {property?.availablefromdate &&
                                      property?.availablefromdate !==
                                        "1970-01-01T00:00:00.000Z" && (
                                        <div className="">
                                          {moment(
                                            property?.availablefromdate
                                          ).format("DD-MM-YYYY")}
                                        </div>
                                      )}
                                  </td>
                                  <td
                                       className="py-2 border-bottom"
                                        style={{ width: "290px", maxWidth: "290px" }}
                                        onClick={(e) => e.stopPropagation()}
                                        >
                                            <div role="button" className="py-1 w-100 font-xs font-weight-semibold position-relative"
                                             onClick={(e) => dropdownClick(e, property?._id, 'ContactDetails')}
                                             >
                                                { property?.contactDetails?.length
                                                        ? property?.contactDetails?.length > 2
                                                            ? property.contactDetails
                                                                .slice(0, 2)
                                                                .map((participant: any) =>
                                                                    participant
                                                                        ? `${participant.contactName || ''}`
                                                                        : ''
                                                                )
                                                                .join(", ")
                                                            : property?.contactDetails?.map((participant: any) =>
                                                                participant
                                                                    ? `${participant.contactName || ''}`
                                                                    : ''
                                                            )
                                                                .join(", ")
                                                        : ""}
                                                <span
                                                    className="text-primary cursor-pointer"
                                                   
                                                >
                                                    {property?.contactDetails?.length > 2 ? ` +${property?.contactDetails?.length - 2}` : ''}
                                                    {property?._id === dropPos?.id && dropPos?.fieldName === 'ContactDetails' &&
                                                         dropPos?.open && (
                                                            renderFieldDetails('Contact Details', property?.contactDetails)
                                                        )}
                                                </span>
                                            </div>
                                        </td>
                                </tr>
                              </>
                            );
                          })}
                        </table>
                      </div>
                    </td>
                  </tr>
                )}
              </>
            );
          })}
        </table>
      </div>
      <div className="d-flex justify-content-between mt-5">
        <div>
          <BottomPagination
            currentPage={props.page || 1}
            totalPages={props.properyData?.totalPages || 0}
            onPageChange={(pg: number) => {
              props.setPage?.(pg);
            }}
            perPage={props.perPage || 20}
            onPerPageChange={(pg: number) => {
              props.setPerPage?.(pg);
            }}
            count={props.properyData?.count}
            label="Record"
          />
        </div>
        <div>
          <button
            type="button"
            onClick={() => {
              props.onSelect?.(selectedProperty!);
              setSelectedProperty([]);
            }}
            className="btn bg-primary px-3 font-normal font-weight-bold text-white"
            disabled={isSaving || !selectedProperty?.length}
          >
            Select Properties
          </button>
        </div>
      </div>
      {projectDetailModal.isOpen && canViewProject && (
        <RequirementPropertyDetailPage
          onClose={() => setProjectDetailModal({})}
          projectId={projectDetailModal.projectId}
          showDetailsOnly={true}
        ></RequirementPropertyDetailPage>
      )}
      {propertyDetailModal.isOpen && canViewProperty && (
        <PropertyDetailPage
          onClose={() => setPropertyDetailModal({})}
          projectId={propertyDetailModal.propertyId}
        ></PropertyDetailPage>
      )}
    </>
  ) : (
    <></>
  );
};

export default SearchProperty;
